import { Typography, TypographyProps } from '@mui/material'
import { useCountdown } from '../../../sharedComponents/src/hooks/useCountdown'
import { COUNTDOWN_TEXT } from '../timing'

interface CountdownTextProps {
    endTime: string
    callback?: () => void
    prefix?: string | JSX.Element
    suffix?: string | JSX.Element
    sx?: TypographyProps['sx']
    variant?: TypographyProps['variant']
}

export const CountdownText: React.FC<CountdownTextProps> = ({
    endTime,
    callback,
    prefix = '',
    suffix = '',
    sx,
    variant = 'body1',
}) => {
    const countdown = useCountdown(endTime, () => setTimeout(() => callback?.(), COUNTDOWN_TEXT.callbackDelay))

    return (
        <Typography variant={variant} sx={{ ...sx, fontVariantNumeric: 'tabular-nums' }}>
            {prefix}
            {countdown}
            {suffix}
        </Typography>
    )
}
